var _rect, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDollarCycleIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.5,
    width: 32,
    height: 32,
    rx: 5.33333,
    fill: "#F7F5FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 23.5C19.866 23.5 23 20.366 23 16.5C23 12.634 19.866 9.5 16 9.5C12.134 9.5 9 12.634 9 16.5C9 20.366 12.134 23.5 16 23.5Z",
    stroke: "#6277FF",
    strokeWidth: 1.05
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9999 12.2998V20.6998M18.0999 14.7498C18.0999 13.7838 17.1598 12.9998 15.9999 12.9998C14.84 12.9998 13.8999 13.7838 13.8999 14.7498C13.8999 15.7158 14.84 16.4998 15.9999 16.4998C17.1598 16.4998 18.0999 17.2838 18.0999 18.2498C18.0999 19.2158 17.1598 19.9998 15.9999 19.9998C14.84 19.9998 13.8999 19.2158 13.8999 18.2498",
    stroke: "#6277FF",
    strokeWidth: 1.05,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDollarCycleIcon);
export default __webpack_public_path__ + "static/media/dollarCycleIcon.fe2b05fb3b48ad0263545008d66a92ff.svg";
export { ForwardRef as ReactComponent };